import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: {
    current: null,
    history: [],
    incrementalHistory: [],
    lastSuccessAt: null,
    lastErrorAt: null,
    lastIncrementalSuccessAt: null,
  },
  loading: {
    status: false,
    history: false,
    trigger: false,
  },
  error: {
    status: null,
    history: null,
    trigger: null,
  },
};

const catalogSyncSlice = createSlice({
  name: 'catalogSync',
  initialState,
  reducers: {
    fetchCatalogStatus: (state) => {
      state.loading.status = true;
      state.error.status = null;
    },
    fetchCatalogStatusSuccess: (state, action) => {
      state.loading.status = false;
      state.status = action.payload;
    },
    fetchCatalogStatusFailure: (state, action) => {
      state.loading.status = false;
      state.error.status = action.payload;
    },

    fetchCatalogHistory: (state) => {
      state.loading.history = true;
      state.error.history = null;
    },
    fetchCatalogHistorySuccess: (state, action) => {
      state.loading.history = false;
      state.status = action.payload;
    },
    fetchCatalogHistoryFailure: (state, action) => {
      state.loading.history = false;
      state.error.history = action.payload;
    },

    triggerCatalogUpdate: (state) => {
      state.loading.trigger = true;
      state.error.trigger = null;
    },
    triggerCatalogUpdateSuccess: (state, action) => {
      state.loading.trigger = false;
      // Optimistically update status if needed, or rely on polling/refetch
      if (action.payload) {
         state.status.current = action.payload; 
      }
    },
    triggerCatalogUpdateFailure: (state, action) => {
      state.loading.trigger = false;
      state.error.trigger = action.payload;
    },
  },
});

export const {
  fetchCatalogStatus,
  fetchCatalogStatusSuccess,
  fetchCatalogStatusFailure,
  fetchCatalogHistory,
  fetchCatalogHistorySuccess,
  fetchCatalogHistoryFailure,
  triggerCatalogUpdate,
  triggerCatalogUpdateSuccess,
  triggerCatalogUpdateFailure,
} = catalogSyncSlice.actions;

export default catalogSyncSlice.reducer;

export const selectCatalogSync = (state) => state.catalogSync;
